export interface VerticalSliderChange {
  mute: boolean;
  volume: number;
}
